import React, { useEffect, useState, useRef } from 'react';
import Input from '../components/Input';
import Button from '../components/Button';
import Text from '../components/Text';
import { Link, useNavigate } from "react-router-dom";
import Avatar from '../components/Avatar';
import CookieConsent, { Cookies, getCookieConsentValue, resetCookieConsentValue } from "react-cookie-consent";
import { getCookie, setCookie, killCoockie } from '../assets/js/helper';

function LoginAlready(props) {

    const [avatar, setAvatar] = useState(null);
    const [pseudo, setPseudo] = useState(null);

    // Recup des infos des cookies
    const wPlayer = JSON.parse(getCookie('w-player'));
    console.log('avatar', wPlayer.player);
    console.log('avatar', wPlayer.player.avatar);
    console.log('pseudo', wPlayer.player.pseudo); 
    // wPlayer.player.avatar = ! null && 
    // setAvatar(wPlayer.player.avatar);
    // wPlayer.player.pseudo = ! null && 
    // setPseudo(wPlayer.player.pseudo);

    useEffect(() => {
        setAvatar(wPlayer.player.avatar); 
        setPseudo('Hey '+wPlayer.player.pseudo+'!');
    },[]);    

    return (
        <form className="w-login row w-fullscreen">
            <div className='col-lg-6 bg-blue w-half-left'>
                <img className="w-img-xl" src="/img/categories/login.png" alt="login" />
            </div>
            <div className='col-lg-6 w-half-right'>
                <img className="w-img-lg" src="/img/categories/wordin_full.png" alt="home" />

                <Avatar
                    type="w-avatar-xl"
                    nom={pseudo}
                    text="Prêt pour un WordIn ? "
                    src={avatar}
                    classes="w-avatar w-avatar-xl"
                />
                <Link to="/home">
                    <Button text="Jouer !" classes="w-btn-blue-lg" />
                </Link>


                <Link to="/login" onClick={()=>{killCoockie('w-player')}}>
                    <Text text="Nouvelle connexion" classes="w-text-black-m" />
                </Link>
            </div>
            <CookieConsent
                location="bottom"
                buttonText="Bien sûr !"
                cookieName="w-coockies-acceptation"
                style={{ background: "#0179bf" }}
                buttonStyle={{ color: "#0179bf", fontSize: "13px", borderRadius: "50px", background: "#fff" }}
                expires={150}
            >
                Notre site utilise les coockies pour vous donner une meilleur expérience lors de son utilisation... <b>Avouez que c'est bon les coockies 🍪🍪🍪!</b>

            </CookieConsent>
        </form>
    );
}

export default LoginAlready;